import SectionHead from '../SectionHead'
import { FaClipboardList } from 'react-icons/fa'
import Card from '../../UI/Card'
import { packages } from '../../data'

const Packages = () => {
    return (
    <>
    <section className="packages">
        <div className="container packages__container">
            <SectionHead sectionName="packages" icon={<FaClipboardList />} title="Simplified Ceremonial Pricing Packages..."></SectionHead>
            <div className="packages__wrapper">
                {
                    packages.map(({id, name, desc, price, features}) => {
                        return <Card key={id} className="package">
                            <h3 className="package__name">{name}</h3>
                            <small className="package__description">{desc}</small>
                            <h4 className="package__includes">What You Get:</h4>
                            {
                                features.map(({feature, included}, index) => {
                                    return <p key={index} className={!included ? "package__feature disabled" : "package__feature"}>{feature}</p>
                                })
                            }
                            <h2 className="package__price">{`$${price}`}</h2>
                            <button className="btn lg package__btn">Schedule A Consultation</button>
                        </Card>
                    })
                }
            </div>
        </div>
    </section>
    </>
    )
}

export default Packages